/**
 * Расписание посылок волны (ISSUE-118): тики, точки и награды идут из сида волны отдельным потоком ГПСЧ, поэтому тап не
 * сдвигает криты и появления, а бот симулятора видит то же, что бой.
 */
import type { BalanceData, ParcelRewardDef } from "@newfungame/contracts";
import { createRng, type Rng } from "./rng";

/** Сколько тиков ГПСЧ расписания считает вперёд: длиннее волна не длится (`MAX_WAVE_TICKS`). */
const PLAN_TICKS = 20 * 60 * 30;
const PARCEL_STREAM = 0x70617263;

export interface ParcelEntry {
  /** Номер посылки в волне, с 1. */
  id: number;
  /** Тик волны, на котором она падает. */
  tick: number;
  /** Последний тик, на котором принимается тап: следующая посылка заменяет эту. */
  endTick: number;
  spot: { x: number; y: number };
  reward: ParcelRewardDef;
}

function pick(rewards: readonly ParcelRewardDef[], rng: Rng): ParcelRewardDef {
  const total = rewards.reduce((s, r) => s + r.weight, 0);
  let roll = rng.int(1, total);
  for (const r of rewards) {
    roll -= r.weight;
    if (roll <= 0) return r;
  }
  return rewards[rewards.length - 1]!;
}

/** Посылки волны. Раздела в балансе нет или волна раньше `fromWave` — пусто. Отсчёт от конца паузы перед волной. */
export function parcelPlan(balance: BalanceData, wave: number, seed: number): ParcelEntry[] {
  const def = balance.parcels;
  if (!def || wave < def.fromWave) return [];
  const rng = createRng((seed ^ PARCEL_STREAM) >>> 0);
  const out: ParcelEntry[] = [];
  let tick = balance.waves.breakTicks + rng.int(def.firstMinTicks, def.firstMaxTicks);
  while (tick < PLAN_TICKS) {
    const gap = rng.int(def.gapMinTicks, def.gapMaxTicks);
    out.push({
      id: out.length + 1,
      tick,
      endTick: tick + Math.min(def.maxLifeTicks, gap) - 1,
      spot: { x: rng.int(0, 1000), y: rng.int(0, 1000) },
      reward: pick(def.rewards, rng),
    });
    tick += gap;
  }
  return out;
}
